import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { AttributeString, attributeStringEnumParser } from '~app-ui-new/utils';

import { UiNewButtonBase } from '../base.component';

export enum FilledButtonVariant {
	PRIMARY = 'PRIMARY',
	WARN = 'WARN',
	TRANSPARENT = 'TRANSPARENT',
}

export enum FilledButtonSize {
	EXTRA_SMALL = 'EXTRA_SMALL',
	SMALL = 'SMALL',
	MEDIUM = 'MEDIUM',
}

@Component({
	selector: '[uiNewButtonFilled]',
	templateUrl: './filled.component.html',
	styleUrls: ['./filled.component.scss', '../base.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
})
export class UiNewButtonFilledComponent extends UiNewButtonBase {
	protected extraClassesKeys: Array<keyof this> = ['variant'];

	private _variant = FilledButtonVariant.PRIMARY;

	@Input()
	public set variant(variant: AttributeString<FilledButtonVariant>) {
		this._variant =
			attributeStringEnumParser(variant, FilledButtonVariant, FilledButtonVariant.PRIMARY) ??
			FilledButtonVariant.PRIMARY;
	}

	public get variant() {
		return this._variant;
	}
}
